export default __webpack_public_path__ + "static/media/notification-01.9cf32d38.m4a";